var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { LoadingButton } from '../../shared';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { Text } from '@amzn/atoz-web/Text';
import { useTranslation } from 'react-i18next';
import { MessageBanner, MessageBannerType } from '@amzn/atoz-web/MessageBanner';
import { View } from '@amzn/atoz-web/View';
import { Row } from '@amzn/atoz-web/Row';
import { DateTime } from 'luxon';
import { timeDifferenceWithDurationString } from '@amzn/atoz-shiftapp-utilities';
import { Col } from '@amzn/atoz-web/Col';
import { useCancelSwapRequestModalContentData } from './utils';
export var CancelSwapRequestModalContent = function (_a) {
    var close = _a.close, scheduleShift = _a.scheduleShift, setModalContent = _a.setModalContent, setModalError = _a.setModalError, siteSwapConfiguration = _a.siteSwapConfiguration, swapRequests = _a.swapRequests;
    var t = useTranslation().t;
    var _b = useCancelSwapRequestModalContentData({
        setModalContent: setModalContent,
        setModalError: setModalError,
        scheduleShift: scheduleShift,
        siteSwapConfiguration: siteSwapConfiguration,
        swapRequests: swapRequests
    }), isSubmitting = _b.isSubmitting, onSubmit = _b.onSubmit, siteId = _b.siteId, swapFromDate = _b.swapFromDate, pendingSwapRequestShifts = _b.pendingSwapRequestShifts;
    var hasMultipleSwapFromShifts = pendingSwapRequestShifts.length > 1;
    var sharedModalContentProps = {
        titleText: t('shift_management_features_CancelSwapRequestModal_title'),
        buttons: [
            React.createElement(Button, { key: "cancelButton", dataTestId: "CancelSwapRequestModalContent_cancelButton", onClick: close, variant: ButtonVariant.Secondary }, t('shift_management_features_CancelSwapRequestModal_closeButton')),
            React.createElement(LoadingButton, { loading: isSubmitting, key: "confirmButton", ariaLabel: t('shift_management_features_CancelSwapRequestModal_confirmButton2'), altText: t('shift_management_common_button', {
                    label: t('shift_management_features_CancelSwapRequestModal_confirmButton2')
                }), dataTestId: "CancelSwapRequestModalContent_confirmButton", onClick: onSubmit, spinnerColor: SpinnerColorScheme.Inverted, buttonVariant: ButtonVariant.Primary, buttonText: t('shift_management_features_CancelSwapRequestModal_confirmButton2') })
        ],
        onCloseButtonClick: close,
        closeButtonAltText: t('shift_management_common_closeModalButton')
    };
    if (!swapFromDate) {
        return (React.createElement(ModalContent, __assign({ dataTestId: "CancelSwapRequestModalContent_Error" }, sharedModalContentProps),
            React.createElement(Col, { gridGap: "S300" },
                React.createElement(Text, null, t('shift_management_features_CancelSwapRequestModal_body_generic')))));
    }
    return (React.createElement(ModalContent, __assign({ dataTestId: "CancelSwapRequestModalContent" }, sharedModalContentProps),
        React.createElement(Col, { gridGap: "S300" },
            hasMultipleSwapFromShifts && (React.createElement(MessageBanner, { dataTestId: "CancelSwapRequestModalContent_multipleShiftBanner", type: MessageBannerType.Informational },
                React.createElement(Text, null, t('shift_management_features_CancelSwapRequestModal_multipleShiftBanner', {
                    swapFromDate: swapFromDate
                })))),
            React.createElement(Text, { fontWeight: "medium", role: "heading", "aria-level": 3 }, t('shift_management_features_CancelSwapRequestModal_subtitle')),
            React.createElement(Text, { dataTestId: "originalShiftString", lineHeight: 0.5 }, swapFromDate),
            React.createElement(View, { backgroundColor: "neutral05", padding: ['S300', 'S400'], margin: { top: 'S100' } },
                React.createElement(View, { role: "list" }, pendingSwapRequestShifts.map(function (_a) {
                    var timeRange = _a.timeRange;
                    return (React.createElement(View, { key: "OriginalShift-".concat(timeRange.start, "-").concat(timeRange.end), dataTestId: "OriginalShift-".concat(timeRange.start, "-").concat(timeRange.end), padding: { top: 'S200', bottom: 'S200' }, role: "listitem" },
                        React.createElement(Text, { dataTestId: "originalShiftDurationString", fontWeight: "medium" }, timeDifferenceWithDurationString(DateTime.fromISO(timeRange.start), DateTime.fromISO(timeRange.end)))));
                })),
                siteId && (React.createElement(Row, { padding: { top: 'S100' } },
                    React.createElement(Text, null, siteId)))),
            React.createElement(Text, null, hasMultipleSwapFromShifts
                ? t('shift_management_features_CancelSwapRequestModal_body_multipleShift')
                : t('shift_management_features_CancelSwapRequestModal_body')))));
};
